import ToolbarView from "app/WebView/Toolbar/ToolbarView"
import {ToolbarButtons} from "app/WebView/Toolbar/ToolbarView.model"
import React from "react"
import {useMemo} from "react"
import {useTranslation} from "react-i18next"
import {layoutStore} from "store/module/layout/layout.store"

function LayoutToolbar() {

  const {t} = useTranslation('Module.Layout')

  const buttons = useMemo(() => {
    let buttons: ToolbarButtons = {
      second: [{
        id: 'create-layout',
        type: 'create',
        title: t('toolbar.create'),
        onClick: () => {
          layoutStore.update(state => {
            state.create = true
          })
        }
      }],
    }

    //     {
    //       id: 'show-explanation',
    //       icon: {
    //         icon: SupportIcon,
    //         props: {
    //           id: 'show-explanation',
    //           variant: 'secondary',
    //           onClick: () => {
    //             // setSystemModuleUi({showHelp: !activeSystemModuleUi?.showHelp ?? true})
    //           },
    //           active: false
    //         },
    //       },
    //     }

    return buttons
  }, [])

  return <ToolbarView buttons={buttons}/>
}

export default LayoutToolbar
